/* trc-deck-feedback.js: GENERATED from table-ready-cards-upload-worker/src/deck-feedback.mjs
 * (sha256 eaa115118dc9f4c5b556ca06ebf8e66c184c3a42bd612aea3842a05fff11dca4) by scripts/build-deck-feedback-umd.mjs. Do not edit this copy:
 * change the source, rebuild, and update every pin. Exposes window.TRCDeckFeedback (or module.exports). */
(function (root, factory) {
  var api = factory();
  if (typeof module === "object" && module && module.exports) module.exports = api;
  else root.TRCDeckFeedback = api;
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function () {
"use strict";
// Deck check wording and small helpers shared by every surface that checks a
// deck in the browser: the product page (theme assets/trc-deck-feedback.js,
// built from this file by scripts/build-deck-feedback-umd.mjs) and the Link
// Creator page (app extensions/trc-link-creator/src/deck-feedback.mjs, a
// verbatim copy). This file is the source of truth. Change it here, rebuild
// the UMD copy, update src/deck-feedback.pins.json, then copy both files and
// the two vector files (deck-feedback-vectors.json, product-rule-vectors.json)
// byte for byte into the other repos.
//
// Rules for this file, so it runs unchanged in a Worker, Node, the Shopify
// extension runtime and Safari 14:
//   - pure: no imports, no DOM, no window, no network, no clock;
//   - every export is a top-level `export const` or `export function` (the
//     UMD build strips the keyword and lists the names);
//   - no optional chaining, no `??`, no regex lookbehind;
//   - shopper copy is plain US English with no em or en dashes, and never
//     says "studio", "proxy" or "MPC".
//
// The server owns the product rule messages (the upload Worker's
// countRangeMessage and the Link Creator matrix verdicts). This file holds
// the wording the browser shows before or around a server check.

const DECK_FEEDBACK_VERSION = 1;

// Same limits as the upload Worker: a pasted list must fit checkout (96 KB of
// cleaned text, 1,000 cards); a list file is read up to 256 KB; a deck_list
// URL param carries at most 6,000 characters.
const LIST_LIMITS = Object.freeze({
  maxBytes: 96 * 1024,
  maxCards: 1000,
  maxFileBytes: 256 * 1024,
  maxDeckListParamChars: 6000,
});

const MESSAGES = Object.freeze({
  checkingNames: "Checking card names…",
  checkingLink: "Checking deck access and card count…",
  routing: "Finding the right product for this deck…",
  refreshing: "Refreshing deck and art choices…",
  preparingPreviews: "Preparing deck previews…",
  linkCheckFailed: "We couldn’t check this deck. Press Refresh to try again.",
  emptyLink: "Paste a public or unlisted deck link from Moxfield, Archidekt, Cube Cobra, or TopDeck.",
  unsupportedLink: "We can’t read this link. Use a public or unlisted deck link from Moxfield, Archidekt, Cube Cobra, or TopDeck.",
  invalidLine: "Every card line must start with a quantity, for example: 1 Sol Ring.",
  companionHint: " To add a companion, use the Deck URL tab.",
  sideboardOptionHint: " Or choose the Mainboard + Sideboard option.",
  listTooLarge: "Decklist is too large to check out (max 96 KB). Remove comments or blank lines and try again.",
  tooManyCards: "Decklist exceeds 1000 cards",
  fileTooLarge: "This list exceeds the 256 KB limit.",
  fileUnreadable: "We couldn’t read the cards in this file. Export the deck again, or paste the list instead.",
  deckChanged: "Deck changed. Please validate the current deck.",
  deckLinkUnavailable: "This deck link is no longer available. You can still paste a list or a deck URL.",
  retryFallback: "Upload failed",
});

// "1 card", "2 cards".
function cardWord(count) {
  return count + (count === 1 ? " card" : " cards");
}

// --- Decklist text: section headers and deck-site markers ---
// DECKLIST_SECTION_HEADER, sectionHeaderName and cleanDecklistText match the
// upload Worker's src/art-resolver.js (which signs the cleaned text); the
// shared fixtures/decklist-section-vectors.json pins every copy.
const DECKLIST_SECTION_HEADER = /^(?:commanders?|companions?|deck|main(?:\s*(?:deck|board))?|sideboard|side\s+board|sb|maybe(?:\s*board)?|considering)\s*:?\s*(?:\(\s*\d+\s*\))?\s*:?$/i;
const SECTION_HEADER_NAMES = [
  [/^commanders?$/i, "Commander"],
  [/^companions?$/i, "Companion"],
  [/^(?:deck|main(?:\s*(?:deck|board))?)$/i, "Deck"],
  [/^(?:sideboard|side\s+board|sb)$/i, "Sideboard"],
  [/^(?:maybe(?:\s*board)?|considering)$/i, "Maybeboard"],
];
const PLAIN_SECTION_HEADER = /^(?:sideboard|sb|maybeboard|maybe board|commander|deck)\s*:?$/i;

// The one spelling of a section header line ("Sideboard (15):" -> "Sideboard"),
// or "" when the line is not a header.
function sectionHeaderName(line) {
  const text = String(line || "");
  if (!DECKLIST_SECTION_HEADER.test(text)) return "";
  const word = text.replace(/\(\s*\d+\s*\)/, "").replace(/:/g, "").trim();
  for (let i = 0; i < SECTION_HEADER_NAMES.length; i++) {
    if (SECTION_HEADER_NAMES[i][0].test(word)) return SECTION_HEADER_NAMES[i][1];
  }
  return "";
}

// A pasted list as TRC signs it: plain headers, no Arena About/Name lines, no
// Archidekt [Category] or ^Label^ blocks ({noDeck} cards other than Sideboard
// dropped), "SB: N Name" lines moved to a Sideboard section at the end.
// Dropped lines stay blank so line numbers still point at the shopper's lines.
function cleanDecklistText(value) {
  const lines = String(value || "").replace(/\r\n?/g, "\n").split("\n");
  const out = [];
  const sideboard = [];
  let seenCard = false;
  for (let i = 0; i < lines.length; i++) {
    const raw = lines[i];
    const line = raw.trim();
    if (!line || /^\/\//.test(line)) { out.push(raw); continue; }
    if (/^about$/i.test(line) || (!seenCard && /^name\s+\S/i.test(line))) { out.push(""); continue; }
    const header = sectionHeaderName(line);
    if (header) { out.push(PLAIN_SECTION_HEADER.test(line) ? raw : header); continue; }
    const sb = /^sb:\s*(\d.*)$/i.exec(line);
    let card = sb ? sb[1].trim() : line;
    if (/^\d/.test(card)) {
      let rest = card;
      let dropped = false;
      for (;;) {
        const block = /\s*(\^[^^]*\^|\[[^[\]]*\])\s*$/.exec(rest);
        if (!block || block.index === 0) break;
        if (block[1].charAt(0) === "[" && /\{nodeck\}/i.test(block[1])
          && !block[1].slice(1, -1).split(",").some(function (part) { return /^\s*side\s*board\s*$/i.test(part.replace(/\{[^}]*\}/g, "")); })) dropped = true;
        rest = rest.slice(0, block.index);
      }
      if (dropped) { out.push(""); continue; }
      card = rest;
      seenCard = true;
    }
    if (sb) { sideboard.push(card); out.push(""); }
    else out.push(card === line ? raw : card);
  }
  if (sideboard.length) {
    if (out.length && out[out.length - 1].trim()) out.push("");
    out.push("Sideboard");
  }
  return out.concat(sideboard).join("\n");
}

// The product page's live count of a pasted list, counted as the Worker signs
// it (cleaned): {total, invalidLines, sections}. sections lists the header
// names seen ("Commander", "Companion", "Deck", "Sideboard", "Maybeboard") in
// first-seen order. A line that is not a header, a comment or "N Name" is
// invalid and is not counted.
function tallyDecklist(value) {
  let total = 0;
  let invalidLines = 0;
  const sections = [];
  const lines = cleanDecklistText(value).split("\n");
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i].trim();
    if (!line || /^\/\//.test(line)) continue;
    if (DECKLIST_SECTION_HEADER.test(line)) {
      const name = sectionHeaderName(line);
      if (name && sections.indexOf(name) === -1) sections.push(name);
      continue;
    }
    const match = line.match(/^(\d+)\s*x?\s+\S/i);
    if (!match) { invalidLines++; continue; }
    total += parseInt(match[1], 10);
  }
  return {total: total, invalidLines: invalidLines, sections: sections};
}

// "This deck needs at least 60 cards."
function minimumMessage(minimum) {
  return "This deck needs at least " + cardWord(minimum) + ".";
}

// "This deck has 117 cards. This option prints up to 100 cards. Remove 17 cards to continue."
function overLimitMessage(count, maximum) {
  return "This deck has " + cardWord(count) + ". This option prints up to " + cardWord(maximum)
    + ". Remove " + cardWord(count - maximum) + " to continue.";
}

// The pasted list's own problem before any server check, or "".
// rules: {minimum, maximum, commanderCompanion, boardByVariant, board}
//   commanderCompanion: the product offers a Commander companion add-on;
//   boardByVariant: the print option names the board; board: the selected one.
function textListIssue(tally, rules) {
  const t = tally || {};
  const r = rules || {};
  const total = Number(t.total) || 0;
  const sections = t.sections || [];
  const minimum = Math.max(1, Number(r.minimum) || 1);
  const maximum = Number(r.maximum) || 0;
  if (t.invalidLines) return MESSAGES.invalidLine;
  if (total < minimum) return minimumMessage(minimum);
  if (maximum > 0 && total > maximum) {
    let issue = overLimitMessage(total, maximum);
    if (sections.indexOf("Companion") !== -1 && r.commanderCompanion) issue += MESSAGES.companionHint;
    else if (sections.indexOf("Sideboard") !== -1 && r.boardByVariant && r.board === "Mainboard") issue += MESSAGES.sideboardOptionHint;
    return issue;
  }
  return "";
}

// The count beside the list: "37 cards" (any quantity) or "37 / 100 cards".
function countLabel(total, target, exact) {
  return exact ? cardWord(total) : total + " / " + target + " cards";
}

// A shorter deck on a fixed-size print option, which the shopper confirms:
// "This deck has 60 cards. This option prints 100 cards." "" when the option
// is any quantity, a creator deck, an "Up to N" option, or the count fits.
// options: {exact, creatorDeck, variantTitle}
function underCountMessage(count, target, options) {
  const o = options || {};
  if (o.exact || o.creatorDeck || !(count > 0) || count >= target) return "";
  if (/^\s*up to\b/i.test(String(o.variantTitle || ""))) return "";
  return "This deck has " + cardWord(count) + ". This option prints " + cardWord(target) + ".";
}

// The board a print option names; "" when it names none. Same patterns as the
// order-export Worker's variantDeckContents (the upload policy).
function variantDeckContents(title) {
  const value = String(title || "");
  if (/mainboard\s*\+\s*sideboard/i.test(value)) return "Mainboard + Sideboard";
  if (/mainboard\s+only/i.test(value)) return "Mainboard";
  return "";
}

// The product page's count range for a print option, before any server check.
// input: {configuredMaximum, configuredMinimum, variantTitle, productTitle,
// fallbackMaximum, exact}. Any quantity (exact) allows up to 1,000; otherwise
// a configured maximum, else the first 1 to 4 digit number in the option and
// product titles, else the fallback (100).
function variantCountRange(input) {
  const o = input || {};
  let maximum;
  const configured = Number(o.configuredMaximum || 0);
  if (o.exact) maximum = LIST_LIMITS.maxCards;
  else if (configured > 0) maximum = configured;
  else {
    const match = (String(o.variantTitle || "") + " " + String(o.productTitle || "")).match(/\b(\d{1,4})\b/);
    maximum = match ? Number(match[1]) : (Number(o.fallbackMaximum) || 100);
  }
  const minimum = Math.max(1, Math.min(maximum, Number(o.configuredMinimum || 1) || 1));
  return {minimum: minimum, maximum: maximum};
}

// A supported deck link ("" when unsupported): https only, no credentials or
// port; "moxfield.com/decks/x" without a scheme and Moxfield's tab pages
// ("/decks/x/primer") are accepted. Moxfield links come back canonical
// (https://moxfield.com/decks/<id>); Archidekt, Cube Cobra and TopDeck links
// come back as given (url.href), and the upload Worker's normalizeDeckUrl,
// which accepts the same links, makes those canonical.
function canonicalDeckUrl(value) {
  let raw = String(value || "").trim();
  if (!raw || raw.length > 2048) return "";
  if (!/^[a-z][a-z0-9+.-]*:/i.test(raw) && /^(?:www\.)?(?:moxfield\.com|archidekt\.com|cubecobra\.com|topdeck\.gg)\//i.test(raw)) raw = "https://" + raw;
  try {
    const url = new URL(raw);
    if (url.protocol !== "https:" || url.username || url.password || url.port) return "";
    const host = url.hostname.toLowerCase().replace(/^www\./, "");
    const moxfield = /^\/decks\/([A-Za-z0-9._~-]+)(?:\/[A-Za-z-]+)?\/?$/.exec(url.pathname);
    if (host === "moxfield.com" && moxfield) return "https://moxfield.com/decks/" + moxfield[1];
    if ((host === "archidekt.com" && /^\/decks\/\d+(?:\/[^/]*)?\/?$/.test(url.pathname))
      || (host === "cubecobra.com" && /^\/cube\/(?:list|overview)\/[A-Za-z0-9._~-]+\/?$/.test(url.pathname))
      || (host === "topdeck.gg" && /^\/deck\/[A-Za-z0-9._~-]+\/(?:@|%40)?[A-Za-z0-9._~-]+\/?$/i.test(url.pathname))) return url.href;
  } catch (ignore) {
    return "";
  }
  return "";
}

// The deck link field's own problem, or "".
function deckLinkIssue(value) {
  if (!String(value || "").trim()) return MESSAGES.emptyLink;
  return canonicalDeckUrl(value) ? "" : MESSAGES.unsupportedLink;
}

// A pasted list too large to check out, or "" (advisory: the server checks
// the cleaned text again before signing or saving it).
function listSizeIssue(value) {
  const cleaned = cleanDecklistText(value);
  if (utf8Length(cleaned) > LIST_LIMITS.maxBytes) return MESSAGES.listTooLarge;
  if (tallyDecklist(cleaned).total > LIST_LIMITS.maxCards) return MESSAGES.tooManyCards;
  return "";
}

function utf8Length(text) {
  let bytes = 0;
  for (let i = 0; i < text.length; i++) {
    const code = text.charCodeAt(i);
    if (code < 0x80) bytes += 1;
    else if (code < 0x800) bytes += 2;
    else if (code >= 0xd800 && code <= 0xdbff && i + 1 < text.length) {
      const next = text.charCodeAt(i + 1);
      if (next >= 0xdc00 && next <= 0xdfff) { bytes += 4; i++; } else bytes += 3;
    } else bytes += 3;
  }
  return bytes;
}

// The smallest print option a deck of `count` cards fits, or "".
// variants: [{id, minimumCount, maximumCount, board}] in page order; board
// (optional) keeps options that name another board out. Ties keep page order.
function smallestFittingVariant(variants, count, board) {
  let best = null;
  const list = variants || [];
  for (let i = 0; i < list.length; i++) {
    const variant = list[i] || {};
    const minimum = Number(variant.minimumCount || 1);
    const maximum = Number(variant.maximumCount || 0);
    if (!(count >= minimum && count <= maximum)) continue;
    if (board && variant.board && variant.board !== board) continue;
    if (!best || maximum < Number(best.maximumCount)) best = variant;
  }
  return best ? String(best.id) : "";
}

// A Link Creator list id: 12 lowercase Crockford base32 characters.
function isLinkId(value) {
  return typeof value === "string" && /^[0-9a-hjkmnp-tv-z]{12}$/.test(value);
}

// An error message that tells the shopper what to do next: adds
// ". Please try again." unless it already says to retry, refresh or contact us.
function withRetryHint(message) {
  const text = String(message || "").trim() || MESSAGES.retryFallback;
  return /\bagain\b|\bretry\b|\bplease\b|refresh|contact us/i.test(text) ? text : text.replace(/[.!?\s]+$/, "") + ". Please try again.";
}

return Object.freeze({
  DECK_FEEDBACK_VERSION: DECK_FEEDBACK_VERSION,
  LIST_LIMITS: LIST_LIMITS,
  MESSAGES: MESSAGES,
  cardWord: cardWord,
  DECKLIST_SECTION_HEADER: DECKLIST_SECTION_HEADER,
  sectionHeaderName: sectionHeaderName,
  cleanDecklistText: cleanDecklistText,
  tallyDecklist: tallyDecklist,
  minimumMessage: minimumMessage,
  overLimitMessage: overLimitMessage,
  textListIssue: textListIssue,
  countLabel: countLabel,
  underCountMessage: underCountMessage,
  variantDeckContents: variantDeckContents,
  variantCountRange: variantCountRange,
  canonicalDeckUrl: canonicalDeckUrl,
  deckLinkIssue: deckLinkIssue,
  listSizeIssue: listSizeIssue,
  smallestFittingVariant: smallestFittingVariant,
  isLinkId: isLinkId,
  withRetryHint: withRetryHint
});
});
